import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../../contexts/LanguageContext';

export default function Team() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <section id="team" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* 主要团队介绍 - 参考图片的左右分栏设计 */}
        <div className="bg-white rounded-3xl overflow-hidden shadow-2xl mb-24">
          <div className="grid lg:grid-cols-2 gap-0">
            {/* 左侧 - 人物照片 */}
            <div className="relative h-[600px] lg:h-auto">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20Asian%20business%20executive%20in%20modern%20office%20setting%2C%20confident%20smile%2C%20wearing%20dark%20business%20suit%2C%20bright%20natural%20lighting%20from%20large%20windows%2C%20contemporary%20corporate%20environment%2C%20high-end%20professional%20headshot%20photography%2C%20sharp%20focus%2C%20warm%20and%20approachable%20atmosphere%2C%20glass%20and%20steel%20architecture%20background%2C%208K%20ultra%20high%20definition&width=800&height=1000&seq=team-leader-photo-001&orientation=portrait"
                alt="Team Leader"
                className="w-full h-full object-cover object-top"
              />
            </div>

            {/* 右侧 - 深色背景文字区域 */}
            <div className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 p-12 lg:p-16 flex flex-col justify-center">
              <div className="mb-8">
                <div className="inline-block px-6 py-2 bg-white/10 backdrop-blur-sm rounded-full mb-6">
                  <p className="text-xs font-light text-white/80 tracking-widest uppercase">
                    {t('我们的团队', 'Our Team')}
                  </p>
                </div>
                <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
                  {t(
                    '核心团队毕业于国内外顶尖高校，拥有头部互联网公司和金融机构的工作经验，为公司发展提供强有力的支撑。',
                    'Core team graduated from top domestic and international universities, with experience at leading internet companies and financial institutions, providing strong support for company development.'
                  )}
                </h2>
              </div>

              <p className="text-lg text-white/90 leading-relaxed mb-8">
                {t(
                  '团队成员在人工智能、数字娱乐、跨文化产品开发等领域拥有丰富经验，致力于将前沿技术与东方文化深度融合，打造具有全球影响力的创新产品。',
                  'Team members have rich experience in artificial intelligence, digital entertainment, and cross-cultural product development, dedicated to deeply integrating cutting-edge technology with Eastern culture to create innovative products with global influence.'
                )}
              </p>

              <button 
                onClick={() => navigate('/contact')}
                className="inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-red-600 to-red-700 text-white font-medium rounded-full hover:from-red-700 hover:to-red-800 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                {t('加入我们', 'Join Us')}
              </button>
            </div>
          </div>
        </div>

        {/* 团队数据统计 */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="text-center">
            <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-gray-700 to-gray-800 rounded-2xl mx-auto mb-4 shadow-lg">
              <i className="ri-team-line text-3xl text-white"></i>
            </div>
            <div className="text-4xl font-bold text-gray-900 mb-2">20+</div>
            <div className="text-gray-600 text-sm">{t('核心团队成员', 'Core Team Members')}</div>
          </div>
          <div className="text-center">
            <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-gray-700 to-gray-800 rounded-2xl mx-auto mb-4 shadow-lg">
              <i className="ri-global-line text-3xl text-white"></i>
            </div>
            <div className="text-4xl font-bold text-gray-900 mb-2">5+</div>
            <div className="text-gray-600 text-sm">{t('国家和地区', 'Countries & Regions')}</div>
          </div>
          <div className="text-center">
            <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-gray-700 to-gray-800 rounded-2xl mx-auto mb-4 shadow-lg">
              <i className="ri-time-line text-3xl text-white"></i>
            </div>
            <div className="text-4xl font-bold text-gray-900 mb-2">{t('8年', '8 Years')}</div>
            <div className="text-gray-600 text-sm">{t('平均行业经验', 'Average Industry Experience')}</div>
          </div>
        </div>

        {/* 核心团队成员展示 */}
        <div className="mb-24">
          <div className="text-center mb-16">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">{t('核心团队成员', 'Core Team Members')}</h3>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              {t('来自世界一流科技公司和名校的精英团队', 'Elite team from world-class tech companies and prestigious universities')}
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {/* 团队成员 1 */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all border border-gray-100">
              <div className="relative h-80">
                <img
                  src="https://readdy.ai/api/search-image?query=Authentic%20professional%20portrait%20of%20Asian%20male%20technology%20executive%20in%20his%20thirties%2C%20natural%20facial%20features%20and%20realistic%20skin%20texture%2C%20wearing%20elegant%20black%20business%20casual%20attire%2C%20genuine%20confident%20smile%20with%20natural%20expression%2C%20photographed%20in%20bright%20modern%20office%20with%20floor-to-ceiling%20windows%2C%20soft%20natural%20daylight%20creating%20realistic%20shadows%20and%20highlights%2C%20contemporary%20glass%20and%20steel%20architecture%20visible%20in%20background%2C%20shot%20with%20professional%20camera%20using%20shallow%20depth%20of%20field%2C%20photorealistic%20quality%20with%20natural%20color%20grading%2C%20no%20artificial%20smoothing%20or%20digital%20enhancement%2C%208K%20resolution%20professional%20corporate%20headshot&width=600&height=800&seq=realistic-tech-exec-male-v2&orientation=portrait"
                  alt="CTO"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                  <h4 className="text-xl font-bold text-white mb-1">{t('张浩', 'Henry Zhang')}</h4>
                  <p className="text-white/90 text-sm">{t('CTO & 联合创始人', 'CTO & Co-Founder')}</p>
                </div>
              </div>
              <div className="p-6">
                <div className="flex flex-wrap gap-2 mb-4">
                  <span className="px-3 py-1 bg-red-50 text-red-600 text-xs rounded-full border border-red-200">{t('AI算法', 'AI Algorithms')}</span>
                  <span className="px-3 py-1 bg-gray-100 text-gray-700 text-xs rounded-full border border-gray-200">{t('深度学习', 'Deep Learning')}</span>
                  <span className="px-3 py-1 bg-orange-50 text-orange-600 text-xs rounded-full border border-orange-200">{t('计算机视觉', 'Computer Vision')}</span>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {t(
                    '清华大学计算机博士，曾任字节跳动AI实验室，专注于视频生成和情感计算',
                    'PhD in Computer Science from Tsinghua University, former AI Lab at ByteDance, focusing on video generation and affective computing'
                  )}
                </p>
              </div>
            </div>

            {/* 团队成员 2 */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all border border-gray-100">
              <div className="relative h-80">
                <img
                  src="https://readdy.ai/api/search-image?query=Authentic%20professional%20portrait%20of%20Asian%20female%20product%20designer%20in%20her%20early%20thirties%2C%20natural%20facial%20features%20with%20realistic%20skin%20texture%20and%20subtle%20makeup%2C%20wearing%20sophisticated%20black%20blazer%20over%20white%20blouse%2C%20warm%20genuine%20smile%20with%20natural%20expression%2C%20photographed%20in%20bright%20contemporary%20design%20studio%20with%20large%20windows%2C%20soft%20natural%20daylight%20creating%20realistic%20lighting%20and%20shadows%2C%20minimalist%20modern%20office%20interior%20visible%20in%20background%2C%20shot%20with%20professional%20camera%20using%20natural%20depth%20of%20field%2C%20photorealistic%20quality%20with%20true-to-life%20color%20reproduction%2C%20no%20excessive%20retouching%20or%20artificial%20enhancement%2C%208K%20resolution%20professional%20corporate%20photography&width=600&height=800&seq=realistic-designer-female-v2&orientation=portrait"
                  alt="CPO"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                  <h4 className="text-xl font-bold text-white mb-1">{t('李娜', 'Hanna Li')}</h4>
                  <p className="text-white/90 text-sm">{t('CPO & 联合创始人', 'CPO & Co-Founder')}</p>
                </div>
              </div>
              <div className="p-6">
                <div className="flex flex-wrap gap-2 mb-4">
                  <span className="px-3 py-1 bg-red-50 text-red-600 text-xs rounded-full border border-red-200">{t('产品设计', 'Product Design')}</span>
                  <span className="px-3 py-1 bg-gray-100 text-gray-700 text-xs rounded-full border border-gray-200">{t('用户体验', 'User Experience')}</span>
                  <span className="px-3 py-1 bg-orange-50 text-orange-600 text-xs rounded-full border border-orange-200">{t('创意策划', 'Creative Planning')}</span>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {t(
                    '香港中文大学硕士，曾任腾讯IEG，10年数字娱乐产品设计经验',
                    'Master\'s from Chinese University of Hong Kong, former Tencent IEG, 10 years of digital entertainment product design experience'
                  )}
                </p>
              </div>
            </div>

            {/* 团队成员 3 */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all border border-gray-100">
              <div className="relative h-80">
                <img
                  src="https://readdy.ai/api/search-image?query=Authentic%20professional%20portrait%20of%20Asian%20male%20business%20executive%20in%20his%20mid-thirties%2C%20natural%20facial%20features%20with%20realistic%20skin%20texture%20and%20professional%20appearance%2C%20wearing%20tailored%20charcoal%20gray%20business%20suit%20with%20crisp%20white%20shirt%2C%20confident%20yet%20approachable%20expression%20with%20natural%20smile%2C%20photographed%20in%20modern%20corporate%20office%20with%20floor-to-ceiling%20glass%20windows%2C%20soft%20natural%20daylight%20creating%20realistic%20lighting%20and%20depth%2C%20contemporary%20glass%20and%20steel%20architecture%20visible%20in%20background%2C%20shot%20with%20professional%20camera%20using%20natural%20bokeh%20effect%2C%20photorealistic%20quality%20with%20accurate%20color%20representation%2C%20no%20artificial%20smoothing%20or%20over-processing%2C%208K%20resolution%20professional%20executive%20portrait&width=600&height=800&seq=realistic-business-exec-male-v2&orientation=portrait"
                  alt="COO"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                  <h4 className="text-xl font-bold text-white mb-1">{t('王伟', 'Ethan Wong')}</h4>
                  <p className="text-white/90 text-sm">{t('COO & 联合创始人', 'COO & Co-Founder')}</p>
                </div>
              </div>
              <div className="p-6">
                <div className="flex flex-wrap gap-2 mb-4">
                  <span className="px-3 py-1 bg-red-50 text-red-600 text-xs rounded-full border border-red-200">{t('商业运营', 'Business Operations')}</span>
                  <span className="px-3 py-1 bg-gray-100 text-gray-700 text-xs rounded-full border border-gray-200">{t('市场拓展', 'Market Expansion')}</span>
                  <span className="px-3 py-1 bg-orange-50 text-orange-600 text-xs rounded-full border border-orange-200">{t('战略规划', 'Strategy Planning')}</span>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {t(
                    '北京大学MBA，曾任阿里巴巴，丰富的互联网产品商业化和国际化经验',
                    'MBA from Peking University, former Alibaba, extensive experience in internet product commercialization and internationalization'
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* 团队背景标签 */}
        <div className="flex flex-wrap items-center justify-center gap-4 mb-20">
          <div className="px-8 py-4 bg-white backdrop-blur-sm rounded-full shadow-md border border-gray-200 hover:shadow-lg transition-all">
            <div className="flex items-center space-x-3">
              <i className="ri-building-line text-2xl text-gray-900"></i>
              <span className="text-gray-900 font-medium">{t('985/211高校', '985/211 Universities')}</span>
            </div>
          </div>
          <div className="px-8 py-4 bg-white backdrop-blur-sm rounded-full shadow-md border border-gray-200 hover:shadow-lg transition-all">
            <div className="flex items-center space-x-3">
              <i className="ri-global-line text-2xl text-gray-900"></i>
              <span className="text-gray-900 font-medium">{t('全球顶尖名校', 'Top Global Universities')}</span>
            </div>
          </div>
          <div className="px-8 py-4 bg-white backdrop-blur-sm rounded-full shadow-md border border-gray-200 hover:shadow-lg transition-all">
            <div className="flex items-center space-x-3">
              <i className="ri-rocket-line text-2xl text-red-600"></i>
              <span className="text-gray-900 font-medium">{t('头部科技公司', 'Top Tech Companies')}</span>
            </div>
          </div>
          <div className="px-8 py-4 bg-white backdrop-blur-sm rounded-full shadow-md border border-gray-200 hover:shadow-lg transition-all">
            <div className="flex items-center space-x-3">
              <i className="ri-earth-line text-2xl text-gray-900"></i>
              <span className="text-gray-900 font-medium">{t('国际化经验', 'International Experience')}</span>
            </div>
          </div>
        </div>

        {/* 团队专业领域 */}
        <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl p-12 mb-24 border border-gray-100">
          <h3 className="text-3xl font-bold text-gray-900 text-center mb-12">{t('团队专业领域', 'Team Expertise')}</h3>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-red-600 to-red-700 rounded-2xl mx-auto mb-4 shadow-lg">
                <i className="ri-brain-line text-2xl text-white"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">{t('人工智能', 'Artificial Intelligence')}</h4>
              <p className="text-gray-600 text-sm">{t('深度学习、计算机视觉、NLP', 'Deep Learning, Computer Vision, NLP')}</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl mx-auto mb-4 shadow-lg">
                <i className="ri-palette-line text-2xl text-white"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">{t('创意设计', 'Creative Design')}</h4>
              <p className="text-gray-600 text-sm">{t('UI/UX设计、品牌、动画', 'UI/UX Design, Branding, Animation')}</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-orange-500 to-red-600 rounded-2xl mx-auto mb-4 shadow-lg">
                <i className="ri-code-s-slash-line text-2xl text-white"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">{t('技术研发', 'Technical R&D')}</h4>
              <p className="text-gray-600 text-sm">{t('全栈开发、云计算、大数据', 'Full-Stack Development, Cloud Computing, Big Data')}</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-gray-700 to-gray-800 rounded-2xl mx-auto mb-4 shadow-lg">
                <i className="ri-line-chart-line text-2xl text-white"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">{t('商业运营', 'Business Operations')}</h4>
              <p className="text-gray-600 text-sm">{t('市场营销、增长、变现', 'Marketing, Growth, Monetization')}</p>
            </div>
          </div>
        </div>

        {/* 荣誉与资质 */}
        <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl p-16 shadow-2xl mb-16 border border-gray-200">
          <div className="text-center mb-16">
            <h3 className="text-4xl font-bold text-gray-900 mb-4">{t('荣誉与资质', 'Honors & Qualifications')}</h3>
            <div className="w-24 h-1 bg-gradient-to-r from-red-600 to-orange-500 rounded-full mx-auto"></div>
          </div>
          
          <div className="grid md:grid-cols-2 gap-16 mb-16 max-w-6xl mx-auto">
            <div className="flex flex-col">
              <div className="flex items-center space-x-4 mb-8">
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-orange-400 to-red-500 rounded-2xl shadow-xl">
                  <i className="ri-trophy-line text-3xl text-white"></i>
                </div>
                <h4 className="text-2xl font-bold text-gray-900">{t('公司荣誉', 'Company Honors')}</h4>
              </div>
              <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-200 space-y-6 flex-1">
                <div className="flex items-center justify-between bg-gradient-to-r from-orange-50 to-red-50 rounded-2xl p-6 border-2 border-orange-200">
                  <span className="text-lg font-semibold text-gray-700">{t('荣誉总数', 'Total Honors')}</span>
                  <span className="text-4xl font-bold text-orange-600">{t('3项', '3 Awards')}</span>
                </div>
                <div className="space-y-4">
                  <div className="bg-gradient-to-br from-red-50 to-white border-2 border-red-200 rounded-2xl p-5 hover:shadow-lg transition-all">
                    <div className="flex items-start space-x-3">
                      <div className="w-3 h-3 bg-red-600 rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-base text-gray-700 leading-relaxed font-medium">
                        {t('核心成员曾获多项国家级创新创业大赛奖项', 'Core members have won multiple national innovation and entrepreneurship competition awards')}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-gray-50 to-white border-2 border-gray-200 rounded-2xl p-5 hover:shadow-lg transition-all">
                    <div className="flex items-start space-x-3">
                      <div className="w-3 h-3 bg-gray-700 rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-base text-gray-700 leading-relaxed font-medium">
                        {t('前沿技术聚焦视频AIGC生成与处理', 'Cutting-edge technology focused on video AIGC generation and processing')}
                      </p>
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-orange-50 to-white border-2 border-orange-200 rounded-2xl p-5 hover:shadow-lg transition-all">
                    <div className="flex items-start space-x-3">
                      <div className="w-3 h-3 bg-orange-500 rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-base text-gray-700 leading-relaxed font-medium">
                        {t('深度掌握情感感知与交互技术', 'Deep expertise in emotion perception and interaction technology')}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-col">
              <div className="flex items-center space-x-4 mb-8">
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-gray-700 to-gray-900 rounded-2xl shadow-xl">
                  <i className="ri-file-shield-line text-3xl text-white"></i>
                </div>
                <h4 className="text-2xl font-bold text-gray-900">{t('技术资质', 'Technical Qualifications')}</h4>
              </div>
              <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-200 space-y-6 flex-1">
                <div className="flex items-center justify-between bg-gradient-to-r from-gray-50 to-red-50 rounded-2xl p-6 border-2 border-red-200">
                  <span className="text-lg font-semibold text-gray-700">{t('知识产权总数', 'Total IP')}</span>
                  <span className="text-4xl font-bold text-red-600">{t('10项', '10 Items')}</span>
                </div>
                <div className="grid grid-cols-3 gap-4">
                  <div className="bg-gradient-to-br from-gray-50 to-white border-2 border-gray-300 rounded-2xl p-5 text-center hover:shadow-lg transition-all">
                    <div className="text-3xl font-bold text-gray-900 mb-2">1</div>
                    <div className="text-sm text-gray-600 font-medium">{t('专利', 'Patent')}</div>
                  </div>
                  <div className="bg-gradient-to-br from-red-50 to-white border-2 border-red-300 rounded-2xl p-5 text-center hover:shadow-lg transition-all">
                    <div className="text-3xl font-bold text-red-600 mb-2">8</div>
                    <div className="text-sm text-gray-600 font-medium">{t('软著', 'Software Copyrights')}</div>
                  </div>
                  <div className="bg-gradient-to-br from-orange-50 to-white border-2 border-orange-300 rounded-2xl p-5 text-center hover:shadow-lg transition-all">
                    <div className="text-3xl font-bold text-orange-600 mb-2">1</div>
                    <div className="text-sm text-gray-600 font-medium">{t('技术证书', 'Tech Certificate')}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto">
            <div>
              <h4 className="text-xl font-bold text-gray-900 mb-6 text-center">{t('荣誉展示', 'Honors Display')}</h4>
              <div className="bg-white rounded-2xl p-8 shadow-xl border-2 border-gray-200 hover:shadow-2xl transition-all">
                <img
                  src="https://static.readdy.ai/image/78b249b905e2bab988df960bca6da6fd/7a41c47d09ef08324b966e87a93d3609.png"
                  alt="Company Honor Certificate"
                  className="w-full h-auto rounded-xl shadow-lg"
                />
              </div>
            </div>

            <div>
              <h4 className="text-xl font-bold text-gray-900 mb-6 text-center">{t('资质展示', 'Qualifications Display')}</h4>
              <div className="bg-white rounded-2xl p-8 shadow-xl border-2 border-gray-200 hover:shadow-2xl transition-all">
                <img
                  src="https://static.readdy.ai/image/78b249b905e2bab988df960bca6da6fd/468ecd1852a33e989651d6789b6be34e.png"
                  alt="Technical Qualification Certificate"
                  className="w-full h-auto rounded-xl shadow-lg"
                />
              </div>
            </div>
          </div>
        </div>

        {/* 团队文化与价值观 */}
        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-gradient-to-br from-red-600 to-red-700 rounded-2xl p-8 text-white shadow-xl">
            <div className="w-14 h-14 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-xl mb-6">
              <i className="ri-lightbulb-line text-3xl text-white"></i>
            </div>
            <h4 className="text-2xl font-bold mb-4">{t('创新驱动', 'Innovation-Driven')}</h4>
            <p className="text-white/90 leading-relaxed">
              {t(
                '持续探索AI技术前沿，将创新思维融入产品设计的每一个环节',
                'Continuously exploring AI technology frontiers, integrating innovative thinking into every aspect of product design'
              )}
            </p>
          </div>

          <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl p-8 text-white shadow-xl">
            <div className="w-14 h-14 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-xl mb-6">
              <i className="ri-heart-line text-3xl text-white"></i>
            </div>
            <h4 className="text-2xl font-bold mb-4">{t('用户至上', 'User-Centric')}</h4>
            <p className="text-white/90 leading-relaxed">
              {t(
                '深入理解用户需求，精心打磨每一个细节，创造有温度的产品体验',
                'Deeply understanding user needs, carefully polishing every detail to create warm product experiences'
              )}
            </p>
          </div>

          <div className="bg-gradient-to-br from-orange-500 to-red-600 rounded-2xl p-8 text-white shadow-xl">
            <div className="w-14 h-14 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-xl mb-6">
              <i className="ri-team-line text-3xl text-white"></i>
            </div>
            <h4 className="text-2xl font-bold mb-4">{t('协作共赢', 'Collaboration & Win-Win')}</h4>
            <p className="text-white/90 leading-relaxed">
              {t(
                '倡导开放包容的团队文化，鼓励跨界合作，共同成长',
                'Advocating open and inclusive team culture, encouraging cross-border collaboration, growing together'
              )}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
